<div class="row">
  <div class="col-md-6 order-md-2">
    <jaga-password-requirements></jaga-password-requirements>
  </div>

  <div class="col-md-6 order-md-1">
    <jaga-update-password-form></jaga-update-password-form>
  </div>
</div>
